import { PageDto, UserDto } from '../api/core';

export interface UserState {
    loading: number;
    users: UserDto[];
    totalUsers: number;
    loggedInUser?: LoggedInUser;
    availableUsers: PageDto;
}

export enum UserActionTypes {
    LOADING = '@liebherr/users/loading',
    LOADING_DONE = '@liebherr/users/loading_done',
    UPDATE_USER_LANG = '@liebherr/users/update_user_lang',
    UPDATED_LOGGED_IN_USER = '@liebherr/users/updated_logged_in_user',
    LOAD_LOGGED_IN_USER = '@liebherr/users/load_logged_in_user',
    LOADED_LOGGED_IN_USER = '@liebherr/users/loaded_logged_in_user',
}

export const userFeatureKey = 'users';

export class LoggedInUser {
    languageCode?: string;
    tenantId?: string;
    uid?: string;
    username?: string;
    roles: string[];

    constructor(dto: { languageCode?: string; tenantId?: string; uid?: string; username?: string; roles?: string[] }) {
        this.languageCode = dto?.languageCode;
        this.tenantId = dto?.tenantId;
        this.uid = dto?.uid;
        this.username = dto?.username;
        this.roles = dto?.roles || [];
    }
}

export enum UserRoles {
    LCO_ALL_1 = 'LCO-ALL-1',
    LCO_ALL_2 = 'LCO-ALL-2',
    LCO_ALL_3 = 'LCO-ALL-3',
    LCO_GET_1 = 'LCO-GET-1',
    LCO_GET_2 = 'LCO-GET-2',
    LCO_GET_3 = 'LCO-GET-3',
    LCO_PUT_1 = 'LCO-PUT-1',
    LCO_PUT_2 = 'LCO-PUT-2',
    LCO_PUT_3 = 'LCO-PUT-3',
    LCO_POST_1 = 'LCO-POST-1',
    LCO_POST_2 = 'LCO-POST-2',
    LCO_POST_3 = 'LCO-POST-3',
    LCO_DELETE_1 = 'LCO-DELETE-1',
    LCO_DELETE_2 = 'LCO-DELETE-2',
    LCO_DELETE_3 = 'LCO-DELETE-3',
    NOT_POSSIBLE_TEST = 'NOT_POSSIBLE_TEST',
}

export function getUserPermissions(action: 'loadAll' | 'deleteUser' | 'loadAvailableUsers', loggedInUser?: LoggedInUser) {
    switch (action) {
        case 'loadAll': {
            return [UserRoles.LCO_GET_3];
        }
        case 'deleteUser': {
            return [UserRoles.LCO_DELETE_3];
        }
        // case 'loadAvailableUsers': {
        //     return [UserRoles.LCO_DELETE_3];
        // }

        default: {
            return [];
        }
    }
}
